import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  vouchers: [],
  isLoading: false,
  error: null,
};

const slice = createSlice({
  name: 'voucher',
  initialState,
  reducers: {
    setVouchers: (state, action) => {
      state.vouchers = action.payload;
      state.error = null;
    },
    addVoucher: (state, action) => {
      const existingIndex = state.vouchers.findIndex((v) => v.id === action.payload.id);
      if (existingIndex !== -1) {
        state.vouchers[existingIndex] = action.payload;
      } else {
        state.vouchers.push(action.payload);
      }
    },
    updateVoucher: (state, action) => {
      const index = state.vouchers.findIndex((v) => v.id === action.payload.id);
      if (index !== -1) {
        state.vouchers[index] = { ...state.vouchers[index], ...action.payload };
      }
    },
    removeVoucher: (state, action) => {
      state.vouchers = state.vouchers.filter((v) => v.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetVouchers: (state) => {
      state.vouchers = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  setVouchers,
  addVoucher,
  updateVoucher,
  removeVoucher,
  setLoading,
  setError,
  resetVouchers,
} = slice.actions;
